"use client"
import styled from "@emotion/styled"
import ChevronDown from "@eurodrive/ui/icons/ChevronDown"
import { StyledSelectMenuProps } from "@eurodrive/ui/styles"
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material"

const StyledFormControl = styled(FormControl)`
  width: 100%;
  margin-bottom: 24px;
`

function CustomSelect({
  label,
  placeholder,
  options,
  onChange,
  value,
  disabled,
}: {
  label: string
  placeholder: string
  options: { value: number | string; label: string }[]
  onChange: (e: any) => void
  value: number | string | null
  disabled?: boolean
}) {
  return (
    <StyledFormControl>
      <InputLabel id={`${label}`} shrink>
        {label}
      </InputLabel>
      <Select
        variant="outlined"
        labelId={`${label}`}
        label={label}
        IconComponent={(props) => <ChevronDown {...props} />}
        MenuProps={StyledSelectMenuProps}
        displayEmpty
        disabled={disabled}
        value={value}
        onChange={onChange}
        renderValue={(value: unknown) => {
          if (!value) {
            return <Typography color="gray">{placeholder}</Typography>
          }
          return <>{options.find((option) => option.value === value)?.label}</>
        }}
      >
        {options
          .filter((option) => option.label)
          .map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
      </Select>
    </StyledFormControl>
  )
}

export default CustomSelect
